export enum Breakpoint {
  Desktop = 'variants-ljclok93',
  Tablet = 'variants-ljclok931',
  Mobile = 'variants-ljclok932',
}

export enum ContainerIds {
  FormStateBox = 'comp-lmrmtf1b',
  GoalReachedBox = 'comp-m6t3zl9w',
  ExpiredStateBox = 'comp-m78zaxmm',
  FormTitle = 'comp-llkmftz6',
  FormDescription = 'comp-llkmqxmn',
}

export enum PageMap {
  Donate = 'donate',
  ThankYou = 'thank-you',
}

// https://github.com/wix-private/santa-editor/blob/bb7374291b36c58a114a5a8a00e1403a27c73ed4/santa-editor/packages/pages/api/actions/symbols.ts#L152
// https://www.wix-pages.com/wix-base-ui/?path=/story/icons--editor-classic-icons
export enum EditorSymbol {
  AddPage = 'addPagePagesPanel',
  Delete = 'deleteAction',
  Settings = 'settingsAction',
  Duplicate = 'duplicateAction',
}

export const enum PresetDirection {
  Ltr = 'LTR',
  Rtl = 'RTL',
}
export const donatePageUrlPart = 'donate';

export const PullingTimeout = 5000;
